module.exports = __webpack_public_path__ + "img/gps_w.cd2ec538.svg";